export default __webpack_public_path__ + "static/media/et.fd06ab94.jpg";